import React from 'react';
import { CHAIN_KEYS } from '../../chains/interfaces';

const shortenAddress = addr => (addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '');

export const WalletHeaderControls = ({
  isConnected,
  address,
  connectButtonText = 'Connect Wallet',
  onConnect,
  onDisconnect,
  onCopyAddress,
  copyFeedback,
  isDebugMode,
  selectedChainKey,
  toggleTargetNetworkName,
  onSwitchNetwork,
}) => {
  if (!isConnected) {
    return (
      <button className="header-connect-btn" onClick={onConnect}>
        {connectButtonText}
      </button>
    );
  }

  return (
    <>
      {isDebugMode && selectedChainKey === CHAIN_KEYS.ETHEREUM && (
        <button className="switch-network-btn" onClick={onSwitchNetwork}>
          Switch to {toggleTargetNetworkName || 'Mainnet'}
        </button>
      )}
      <div
        className="wallet-address clickable"
        onClick={onCopyAddress}
        title="Click to copy address"
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onCopyAddress();
          }
        }}
        aria-label="Wallet address, click to copy"
      >
        {copyFeedback ? 'Copied!' : shortenAddress(address)}
      </div>
      <button className="disconnect-btn" onClick={onDisconnect} aria-label="Disconnect wallet">
        Disconnect
      </button>
    </>
  );
};
